export default "__VITE_ASSET__D5yFAi5h__"